import React, {useEffect, useRef} from 'react';
import Modal from "react-bootstrap/Modal";
import {connect} from "react-redux";
import {updateAppSettings} from "src/actions/foundationActions";
import {closeModal, loadNewMod} from "src/utilities/utilityFunctions";
import store from 'src/store';
import {updateDataStore} from "src/actions/foundationActions";
import {gsap, Back} from 'gsap';

const TDPModal  = (props) => {
    let statedata = store.getState();
    const modalFooterRef = useRef();
    let modalFooterText = "";
    useEffect(()=>{
        if(modalFooterText.current) {
            gsap.set(modalFooterRef.current, {scale: 0});
        }
        if(statedata.appSettings.modalFooterText){
            gsap.to(modalFooterRef.current,.3,{scale:1,ease:Back.easeOut});
        }
    });

    let closeButtonName = statedata.appSettings.closeButtonName ? statedata.appSettings.closeButtonName : "components/TDP/Modal/ModalCloseButton";

    useEffect(()=>{
         if(closeButtonName){
             loadNewMod(closeButtonName,(module)=>store.dispatch(updateDataStore({modalCloseMod:module.default})));
         }
        //eslint-disable-next-line
    },[closeButtonName]);

    let closeButton = statedata.dataStore.modalCloseMod ? <statedata.dataStore.modalCloseMod triggerName={props.triggerName}/> : null;

    //Determine the name of the correct module to open
    let currentModName = statedata.appSettings.modalModuleName;
    useEffect(()=>{
            if(currentModName){
                loadNewMod(currentModName,(module)=>store.dispatch(updateAppSettings({modalModule:module.default})));
            }
        //eslint-disable-next-line
    },[currentModName]);

    //If the class is established, then open it, otherwise show null;
    let modMod=statedata.appSettings.modalModule ? <statedata.appSettings.modalModule /> : null;

    let modalTitle= statedata.appSettings?.modalTitle ? statedata.appSettings.modalTitle : null;

    let fullStyle = (statedata.appSettings.startModalFullScreen
        ? {position:"fixed",left:"0",top:"0",width:"100vw", background:"white"}
        : {opacity:"1",height:"100%",maxHeight:"100%"});

    let headerStyle=(
        statedata.appSettings.startModalFullScreen
            ? "modal-header-0"
            : "modal-header-1"
    );

    let size=(
        statedata.appSettings.size
            ? statedata.appSettings.size
            : null
    );

    return(
        <Modal id="genericModal" show={statedata.appSettings[props.triggerName]} size={size}
            onHide={()=>closeModal(props.triggerName)}>
            <div id="generickModal" style={fullStyle}>
               <Modal.Header closeButton className={headerStyle}>
                    <Modal.Title id="modalTitle">
                        <span id="realModalTitle_tn" style={{fontFamily: 'Arial',fontSize:"29px",color:"#4c7297"}}>{modalTitle}</span>
                        <div style={{position:"absolute",left:0,bottom:0}}><img src="https://d143ebdtyzz429.cloudfront.net/site/devSupplementalImgs/color-rod.png" alt="color-rod" /></div>
                    </Modal.Title>
               </Modal.Header>
               <Modal.Body>
                  <div style={{display: 'flex', justifyContent: 'center',width: '100%', height:"100%",maxWidth:"100%",maxHeight:"100%"}}>
                        {modMod}
                  </div>
               </Modal.Body>
               <Modal.Footer>
                  <div style={{display:"flex",width:"100%",justifyContent:"space-between"}}>
                    <div ref={modalFooterRef} style={{fontFamily: 'Arial',fontSize:"25px",color:"#4c7297"}}><span>{statedata.appSettings.modalFooterText}</span></div>
                    <span>{closeButton}</span>
                </div>
               </Modal.Footer>
            </div>
        </Modal>
    )
};

const mapStateToProps = (state) =>{
    return  {
        appSettings:state.appSettings,
        dataStore:state.dataStore
    };
};

export default connect(mapStateToProps,{
    updateAppSettings,
    updateDataStore
})(TDPModal);
